'use server'

import { apiRequest, ApiResponse } from '../request'

/**
 * Prompt do usuário de IA no painel MASTER (Integrações > Agente). Ver docs/ai-user.md,
 * "Prompt no banco".
 */

const BASE = 'ai-user/prompt'

export type AiUserPromptLayer = 'PLATFORM' | 'ROLE'
export type AiUserPromptSectionKind = 'system' | 'step'

export interface AiUserPromptPlaceholder {
    name: string
    description: string
    required?: boolean
}

export interface AiUserPromptSection {
    id: number
    key: string
    layer: AiUserPromptLayer
    role: string | null
    kind: AiUserPromptSectionKind
    title: string
    description: string | null
    isCustom: boolean
    enabled: boolean
    sortOrder: number
    placeholders: AiUserPromptPlaceholder[]
    content: string
    defaultContent: string | null
    versionCount: number
    updatedAt: string | null
    updatedBy: { id: number; name: string } | null
}

export interface AiUserPromptVersion {
    id: number
    content: string
    note: string
    createdAt: string
    createdBy: { id: number; name: string } | null
}

export interface AiUserPromptPreview {
    systemPrompt: string
    systemChars: number
    steps: Array<{ step: string; title: string; content: string }>
}

export async function getAiUserPromptSections(): Promise<
    ApiResponse<AiUserPromptSection[]>
> {
    return apiRequest<AiUserPromptSection[]>(`${BASE}/sections`, {})
}

export async function getAiUserPromptVersions(
    sectionId: number
): Promise<ApiResponse<AiUserPromptVersion[]>> {
    return apiRequest<AiUserPromptVersion[]>(
        `${BASE}/sections/${sectionId}/versions`,
        {}
    )
}

export async function getAiUserPromptPreview(
    name?: string
): Promise<ApiResponse<AiUserPromptPreview>> {
    return apiRequest<AiUserPromptPreview>(`${BASE}/preview`, {
        params: name ? { name } : {},
    })
}

export async function saveAiUserPromptContent(
    sectionId: number,
    data: { content: string; note: string }
): Promise<ApiResponse<{ success: boolean }>> {
    return apiRequest(`${BASE}/sections/${sectionId}/content`, { data }, 'put')
}

export async function restoreAiUserPromptVersion(
    sectionId: number,
    versionId: number
): Promise<ApiResponse<{ success: boolean }>> {
    return apiRequest(
        `${BASE}/sections/${sectionId}/versions/${versionId}/restore`,
        {},
        'post'
    )
}

export async function createAiUserPromptSection(data: {
    title: string
    layer: AiUserPromptLayer
    content: string
    note: string
}): Promise<ApiResponse<{ id: number }>> {
    return apiRequest(`${BASE}/sections`, { data }, 'post')
}

export async function updateAiUserPromptSection(
    sectionId: number,
    data: { title?: string; enabled?: boolean; sortOrder?: number }
): Promise<ApiResponse<{ success: boolean }>> {
    return apiRequest(`${BASE}/sections/${sectionId}`, { data }, 'patch')
}
